export default __webpack_public_path__ + "static/81dab9538ade6537fe63c382d760a638.jpg";